import React from 'react';
import { Modal, Input, Button, Alert } from 'antd';
import { CheckCircleOutlined, CopyOutlined } from '@ant-design/icons';

interface SuccessModalProps {
	showModal: boolean;
	generatedLink: string;
	accountDetails: any;
	onClose: () => void;
	onCopyLink: (text: string) => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
	showModal,
	generatedLink,
	accountDetails,
	onClose,
	onCopyLink,
}) => {
	const handleCopyLink = (): void => {
		onCopyLink(generatedLink);
	};

	const renderAccountDetails = (): JSX.Element | null => {
		if (!accountDetails) {
			return null;
		}

		return (
			<div className="mt-4 text-left">
				<p className="text-sm text-gray-500 mb-2">Account created:</p>
				<Alert
					message={
						<div className="space-y-1">
							{[
								{ label: 'Username', value: accountDetails.username },
								{ label: 'Email', value: accountDetails.emailAddress },
								{ label: 'Customer ID', value: accountDetails.customerId },
								{
									label: 'Business Name',
									value: accountDetails.businessName || 'Not provided',
								},
								{
									label: 'Business Type',
									value: accountDetails.businessType || 'Not provided',
								},
							].map(({ label, value }) => (
								<p key={label}>
									<strong>{label}:</strong> {value}
								</p>
							))}
						</div>
					}
					type="info"
					showIcon={false}
					className="bg-blue-50"
				/>
			</div>
		);
	};

	const renderGeneratedLink = (): JSX.Element | null => {
		if (!generatedLink) {
			return null;
		}

		return (
			<>
				<p className="text-sm text-gray-500 mb-4">Your custom offer URL:</p>
				<Input value={generatedLink} readOnly className="mb-4" />
			</>
		);
	};

	return (
		<Modal open={showModal} onCancel={onClose} footer={null} width={400} centered closable={true}>
			<div className="text-center">
				<div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
					<CheckCircleOutlined className="h-6 w-6 text-green-600" />
				</div>

				<h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
					Offer Generated Successfully!
				</h3>

				<div className="mt-4">
					{renderGeneratedLink()}
					{renderAccountDetails()}
				</div>

				<div className="flex justify-center space-x-3 mt-6">
					{generatedLink && (
						<Button type="primary" icon={<CopyOutlined />} onClick={handleCopyLink}>
							Copy URL
						</Button>
					)}
					<Button onClick={onClose}>Close</Button>
				</div>
			</div>
		</Modal>
	);
};

export default SuccessModal;
